import { observer } from 'mobx-react';
import { inject } from 'tsdi';

import React, { Component, ErrorInfo, ReactNode } from 'react';

import { Alert, AlertDescription } from '@components/ui/alert';
import { I18n } from '../core/i18n';

interface Props {
    children?: ReactNode;
}
interface State {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    hasError: boolean;
}

@observer

// eslint-disable-next-line @typescript-eslint/ban-types
export class ErrorBoundary extends Component<Props, State> {
    @inject
    private i18n!: I18n;

    public state: State = {
        hasError: false
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        const message =
            this.i18n?.__('commons.error.runtime') ??
            'An unexpected error occurred.';
        console.error(message, error, errorInfo);
        return <div>{message}</div>;
    }
    public render() {
        if (this.state.hasError) {
            const message =
                this.i18n?.__('commons.error.runtime') ??
                'An unexpected error occurred.';
            return (
                <div className="flex min-h-[400px] items-center justify-center p-6">
                    <Alert variant="destructive" className="max-w-md">
                        <AlertDescription>{message}</AlertDescription>
                    </Alert>
                </div>
            );
        }

        return this.props.children;
    }
}
